import React, { RefObject } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Text } from '@b_v/components';
import { Button } from '@bice_vida/ds-components-button';
import { BELIV_BY_BICE_BENEFITS } from '@src/constants/urls';
import Image from 'next/image';
import Link from 'next/link';

import styles from './LandingBenefitsExclusive.module.scss';

type LandingBenefitsHeroPropsT = {
  scrollRef?: RefObject<HTMLDivElement>;
};

const LandingBenefitsExclusive: React.FC<LandingBenefitsHeroPropsT> = ({ scrollRef }) => {
  const { t } = useTranslation();

  return (
    <div ref={scrollRef} className={styles.LandingBenefitsExclusive}>
      <Text tag="h4" className={styles.LandingBenefitsExclusive__subtitle}>
        {t('BENEFITS_EXCLUSIVE_SUBTITLE')}
      </Text>
      <Trans
        i18nKey="BENEFITS_EXCLUSIVE_TITLE"
        components={{
          h2: <h2 className={styles.LandingBenefitsExclusive__title} />,
          span: <span />,
        }}
      />
      <Text tag="h3" className={styles.LandingBenefitsExclusive__description}>
        {t('BENEFITS_EXCLUSIVE_DESCRIPTION')}
      </Text>

      <div className={styles.LandingBenefitsExclusive__body}>
        {[1, 2, 3].map((benefit, index) => (
          <div
            key={`benefitExclusive_${benefit}`}
            className={styles.LandingBenefitsExclusive__card}
          >
            <div className={styles.LandingBenefitsExclusive__card__image}>
              <Image src={`/images/benefits/exclusive_${benefit}.webp`} alt="" fill />
            </div>
            <Text tag="h3" className={styles.LandingBenefitsExclusive__card__text}>
              {t(`BENEFITS_EXCLUSIVE.${index}`)}
            </Text>
            <Trans
              i18nKey={`BENEFITS_EXCLUSIVE_DESCRIPTION_BY_BENEFIT.${index}`}
              components={{
                span: <span className={styles.LandingBenefitsExclusive__card__description} />,
                b: <b />,
              }}
            />
          </div>
        ))}
      </div>
      <Link legacyBehavior href={BELIV_BY_BICE_BENEFITS} passHref>
        <a target="_blank" rel="noopener noreferrer">
          <Button variant="secondary" size="xl" className={styles.LandingBenefitsExclusive__button}>
            {t('BENEFITS_EXCLUSIVE_BUTTON')}
          </Button>
        </a>
      </Link>
    </div>
  );
};

export default LandingBenefitsExclusive;
